import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

import Title from '../../Title';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Table from '../Table';

import { Home as HomeIcon } from '@material-ui/icons';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import SalesValueRow from './SalesValueRow';
import PricePaidRow from './PricePaidRow';
import { Tooltip } from '@material-ui/core';

class ResidentialValue extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        // Redux State
        salesLandValues: PropTypes.object,
        pricePaid: PropTypes.array
    };

    constructor (props) {
        super(props);

        this.state = {

        };
    }

    render () {
        const { classes, salesLandValues, pricePaid } = this.props;

        const isLoading = !Boolean(salesLandValues);

        const groupedPricePaid = pricePaid && _(pricePaid)
            .groupBy(x => x.uprn)
            .value();

        return (
            <>
                <Title
                    title="RESIDENTIAL VALUE"
                    skeleton={isLoading}
                >
                </Title>
                <Table
                    headerTitle="Local Sales Values"
                    headerIcon={<HomeIcon />}
                    headings={[
                        'Type',
                        <div className={classes.withTooltip}>
                            £/SQFT
                            <Tooltip arrow title={'Hover over value to see how it was calculated. Percentage indicates the difference compared to the average local authority district value'} placement={'right'}>
                                <InfoOutlinedIcon />
                            </Tooltip>
                        </div>,
                        <div className={classes.withTooltipEnd}>
                            Market Value
                            <Tooltip arrow title={'Average calculated across the local authority district'} placement={'right'}>
                                <InfoOutlinedIcon />
                            </Tooltip>
                        </div>
                    ]}
                    skeleton={isLoading}
                >
                    {salesLandValues &&
                        <>
                            <SalesValueRow type={'Detached'} {...salesLandValues.detached} />
                            <SalesValueRow type={'Semi-detached'} {...salesLandValues.semidetached} />
                            <SalesValueRow type={'Terraced'} {...salesLandValues.terraced} />
                            <SalesValueRow type={'Flats'} {...salesLandValues.flat} />
                        </>
                    }
                </Table>
                {(isLoading || pricePaid.length > 0) && <Table
                    headerTitle="HMLR Price Paid"
                    headerIcon={<HomeIcon />}
                    headings={['UPRN', 'Type', 'Price Paid', 'Purchased']}
                    skeleton={isLoading}
                >
                    {groupedPricePaid &&
                        Object.keys(groupedPricePaid).map(key =>
                            <PricePaidRow
                                key={key}
                                uprn={key}
                                pricePaid={groupedPricePaid[key]}
                            />)
                    }
                </Table>}
            </>
        );
    }
}

const style = theme => ({
    withTooltip: {
        display: 'flex',
        alignItems: 'center',
        '&> svg': {
            fontSize: '1em',
            marginLeft: 6
        }
    },
    withTooltipEnd: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        '&> svg': {
            fontSize: '1em',
            marginLeft: 6
        }
    }
});

const mapStateToProps = (state) => {
    const currentPolygon = state.parcelPanel.currentPolygonId && state.parcelPanel.polygons[state.parcelPanel.currentPolygonId];
    const currentTitle = currentPolygon && state.parcelPanel.titles[currentPolygon.titleNo];
    return {
        salesLandValues: currentPolygon && currentPolygon.value,
        pricePaid: currentTitle && currentTitle.pricePaid
    };
};

const mapDispatchToProps = (dispatch) => ({

});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(ResidentialValue);